/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Helpers.CustomSignupFieldValidator = class CustomSignupFieldValidator {
  constructor(field) {
    this.field = field;
  }

  isValid() {
    if (this.field.val().length === 0) { return false; }
    if ((this.field.data('pattern') == null) || (this.field.data('pattern').length === 0)) { return true; }
    return (this.field.val().match(this.field.data('pattern')) != null);
  }
};
